import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotGossipGrid from './components/HotGossipGrid';
import CategoryFeatured from './components/CategoryFeatured';
import { JsonLd, getOrganizationSchema, getWebSiteSchema } from '@/components/base/JsonLd';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={getOrganizationSchema()} />
      <JsonLd data={getWebSiteSchema()} />
      <Navbar />
      <main>
        <HeroSection />
        <HotGossipGrid />
        <CategoryFeatured />
      </main>
      <Footer />
    </div>
  );
}